module.exports = __webpack_public_path__ + "img/1017.6e8fefe3.svg";